import SettingTypes from "@/utils/setting-types";

export default {
  name: 'goods-module',
  label: {
    title: '商品列表模块',
    icon: require('@/assets/icon-component-label_ImageSudoku.svg'),
    limit: 1
  },
  decor_type: 'admin',
  sort: 998,
  data: {
    // 商品类型【NORMAL：自营，JD：京东，ZN：助农, SM：山姆, YH：永辉】
    goods_type: 'NORMAL',
    // 列表样式
    list_style: 'double-row',
    // 商品倒角
    goods_chamfer: 'round',
    // 页面边距
    page_edge: 30,
    // 图片间距
    image_space: 20,
    // 商品背景颜色
    goods_background_color: '#f9f0e7',
    // 边框颜色
    goods_border_color: '#ffffff',
    // 显示商品地址
    show_goods_region: true,
    // 商品地址样式
    goods_region_style: 'custom',
    // 商品地址样式图片
    goods_region_image: 'http://joiestshop.oss-cn-beijing.aliyuncs.com/achitecture/normal/5DE1476C8EEE489E8569F73D9A8BDFC1.png',
    // 商品地址颜色
    goods_region_color: '#ef7828',
    // 商品标识
    show_goods_self: true,
    // 显示商品名称
    show_goods_name: true,
    // 商品名称样式
    goods_name_style: 'custom',
    // 商品名称样式背景图
    goods_name_bg_style: 'http://joiestshop.oss-cn-beijing.aliyuncs.com/achitecture/normal/6879A62CFED744DF843DA07C1AA01309.png',
    // 商品名称颜色
    goods_name_color: '#ffffff',
    // 商品名称样式
    text_font_weight: 'bold',
    // 商品名称字体大小
    text_font_size: 36,
    // 显示商品描述
    show_goods_brief: true,
    // 商品说明颜色
    goods_brief_color: '#621c19',
    // 商品说明样式
    goods_brief_style: 'custom',
    // 商品说明样式默认图片
    goods_brief_bg_style: 'http://joiestshop.oss-cn-beijing.aliyuncs.com/achitecture/normal/366CC964B8F64D69A753D7EFF1D89DAD.png',
    // 显示商品价格
    show_goods_price: true,
    // 商品价格字体大小
    price_font_size: 42,
    // 商品价格字体样式
    price_font_weight: 'bold',
    // 商品价格颜色
    goods_price_color: '#ef1e0a',
    // 显示商品购买按钮
    show_goods_buy_btn: true,
    // 商品购买按钮默认样式9
    goods_buy_btn_style: 9,
    // 商品购买按钮默认文字
    goods_buy_btn_text: '立即购买',
    // 自定义商品购买按钮图片
    buy_btn_style_image: '',
    // 显示商品名称
    show_goods_name_x: true
  },
  settings: {
    goods_type: {
      type: SettingTypes.select,
      label: '商品类型',
      options: [
        { label: '自营', value: 'NORMAL' },
        { label: '京东', value: 'JD' },
        { label: '助农', value: 'ZN' },
        { label: '助农-新', value: 'ZN-X' },
        { label: '山姆', value: 'SM' },
        { label: '永辉', value: 'YH' }
      ]
    },
    list_style: {
      type: SettingTypes.radio_button,
      label: '列表样式',
      options: [
        { label: '单排', value: 'single-row', icon: 'rb-icon-list' },
        { label: '双排', value: 'double-row', icon: 'rb-icon-small' }
      ],
      show: data => data.goods_type !== 'ZN' && data.goods_type !== 'ZN-X'
    },
    goods_chamfer: {
      type: SettingTypes.radio_button,
      label: '商品倒角',
      options: [
        { label: '直角', value: 'straight', icon: 'rb-icon-corner-straight' },
        { label: '圆角', value: 'round', icon: 'rb-icon-corner-round' }
      ],
      show: data => data.goods_type === 'ZN' || data.goods_type === 'ZN-X'
    },
    page_edge: {
      type: SettingTypes.slider,
      label: '页面边距',
      props: {
        min: 0,
        max: 60
      },
      show: data => data.goods_type === 'ZN' || data.goods_type === 'ZN-X'
    },
    goods_background_color: {
      type: SettingTypes.color_picker,
      label: '背景颜色',
      default: '#ffffff',
      show: data => data.goods_type === 'ZN' || data.goods_type === 'ZN-X'
    },
    goods_border_color: {
      type: SettingTypes.color_picker,
      label: '边框颜色',
      default: '#ffffff',
      space_line: true,
      show: data => data.goods_type === 'ZN'
    },
    show_goods_region: {
      type: SettingTypes.boolean,
      label: '商品地址',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      option: {
        key: 'goods_region_style',
        options: [
          { label: '默认样式', value: 'default' },
          { label: '自定义', value: 'custom' }
        ],
        custom_component_name: 'GoodsSettingCustomRegionStyle'
      },
      show: goodsSettingShow
    },
    goods_region_color: {
      type: SettingTypes.color_picker,
      label: `地址颜色`,
      default: '',
      space_line: true,
      show: data => data.show_goods_region && data.goods_type === 'ZN'
    },
    show_goods_name: {
      type: SettingTypes.boolean,
      label: '商品名称',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      option: {
        type: 'radio',
        key: 'goods_name_style',
        options: [
          { label: '默认样式', value: 'default' },
          { label: '自定义', value: 'custom' }
        ],
        custom_component_name: 'GoodsSettingCustomNameStyle',
      },
      show: data => data.goods_type === 'ZN'
    },
    show_goods_self: {
      type: SettingTypes.boolean,
      label: '商品标识',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      show: data => data.goods_type === 'ZN-X'
    },
    show_goods_name_x: {
      type: SettingTypes.boolean,
      label: '商品名称',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      show: data => data.goods_type === 'ZN-X'
    },
    goods_name_color: {
      type: SettingTypes.color_picker,
      label: '商品名称颜色',
      default: '',
      show: data => data.show_goods_name && data.goods_type === 'ZN'
    },
    text_font_weight: {
      type: SettingTypes.radio_button,
      label: '商品名称样式',
      options: [
        { label: '常规体', value: '400', icon: 'rb-icon-font-regular' },
        { label: '加粗体', value: 'bold', icon: 'rb-icon-font-bold' }
      ],
      show: data => data.show_goods_name && data.goods_type === 'ZN'
    },
    text_font_size: {
      type: SettingTypes.slider,
      label: '名称字体大小',
      props: {
        min: 12,
        max: 60
      },
      space_line: true,
      show: data => data.show_goods_name && data.goods_type === 'ZN'
    },
    show_goods_brief: {
      type: SettingTypes.boolean,
      label: '商品说明',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      option: {
        type: 'radio',
        key: 'goods_brief_style',
        options: [
          { label: '默认样式', value: 'default' },
          { label: '自定义', value: 'custom' }
        ],
        custom_component_name: 'GoodsSettingCustomBriefStyle'
      },
      show: data => data.goods_type === 'ZN' || data.goods_type === 'ZN-X'
    },
    goods_brief_color: {
      type: SettingTypes.color_picker,
      label: '商品说明颜色',
      default: '',
      space_line: true,
      show: data => data.show_goods_brief && (data.goods_type === 'ZN' || data.goods_type === 'ZN-X')
    },
    show_goods_price: {
      type: SettingTypes.boolean,
      label: '商品价格',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      show: data => data.goods_type === 'ZN' || data.goods_type === 'ZN-X'
    },
    price_font_weight: {
      type: SettingTypes.radio_button,
      label: '商品价格样式',
      options: [
        { label: '常规体', value: '400', icon: 'rb-icon-font-regular' },
        { label: '加粗体', value: 'bold', icon: 'rb-icon-font-bold' }
      ],
      show: data => data.show_goods_price && (data.goods_type === 'ZN' || data.goods_type === 'ZN-X')
    },
    price_font_size: {
      type: SettingTypes.slider,
      label: '价格字体大小',
      props: {
        min: 12,
        max: 60
      },
      show: data => data.show_goods_price && (data.goods_type === 'ZN' || data.goods_type === 'ZN-X')
    },
    goods_price_color: {
      type: SettingTypes.color_picker,
      label: '商品价格颜色',
      default: '',
      space_line: true,
      show: data => data.show_goods_price && (data.goods_type === 'ZN' || data.goods_type === 'ZN-X')
    },
    show_goods_buy_btn: {
      type: SettingTypes.boolean,
      label: '购买按钮',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      option: {
        type: 'radio',
        key: 'goods_buy_btn_style',
        options: [
          { label: '样式1', value: 1 },
          { label: '样式2', value: 2 },
          { label: '样式3', value: 3 },
          { label: '样式4', value: 4 },
          { label: '样式5', value: 5 },
          { label: '样式6', value: 6 },
          { label: '样式7', value: 7 },
          { label: '样式8', value: 8 },
          { label: '样式9', value: 9 },
          { label: '自定义', value: 10 }
        ],
        custom_component_name: 'GoodsSettingCustomBuyBtn'
      },
      show: data => data.goods_type === 'ZN' || data.goods_type === 'ZN-X'
    }
  }
}

/**
 * 助农类型页面设置显示
 * @param data
 * @returns {boolean}
 */
function goodsSettingShow(data) {
  if (data.goods_type === 'ZN') {
    return true
  } else {
    return false
  }
}
